<template>
  <div class="row py-3">
    <section class="col-md-4 label-legend">
      <div class="font-weight-bold">
        <span>
          Informe de Progreso Académico:
        </span>
      </div>
    </section>
    <section class="weeks-container col-md-7">
      <div class="week-10 font-weight-bold">
        <div class="percent" :class="colorStatus(this.progress.week1)">
          <span>
            {{ value(this.progress.week1) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>10 Semanas</span>
        </div>
      </div>
      <div class="week-20 font-weight-bold">
        <div class="percent" :class="colorStatus(this.progress.week2)">
          <span>
            {{ value(this.progress.week2) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>20 Semanas</span>
        </div>
      </div>
      <div class="week-30 font-weight-bold">
        <div class="percent" :class="colorStatus(this.progress.week3)">
          <span>
            {{ value(this.progress.week3) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>30 Semanas</span>
        </div>
      </div>
      <div class="week-40 font-weight-bold">
        <div class="percent" :class="colorStatus(this.progress.week4)">
          <span>
            {{ value(this.progress.week4) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>40 Semanas</span>
        </div>
      </div>
      <div class="week-50 font-weight-bold">
        <div class="percent" :class="colorStatus(this.progress.week5)">
          <span>
            {{ value(this.progress.week5) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>50 Semanas (AEE)</span>
        </div>
      </div>
      <div class="avg font-weight-bold">
        <div class="percent">
          <span>
            {{ percentageTotal(this.progress.total) | empty }}
          </span>
        </div>
        <div class="week-description">
          <span>Promedio</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { pieAcademicProgress } from '@/utils/constants/pei/progress-report-educational-services/pieAcademicProgress';
export default {
  name: 'WeeklyProgressLegend',
  props: {
    progress: {
      type: Object,
      default: () => ({
        week1: null,
        week2: null,
        week3: null,
        week4: null,
        total: null,
      }),
    },
  },
  computed: {
    value() {
      return (item) =>
        item.isNt ? 'NT' : item.status == 6 ? 'N/A' : this.percentage(item);
    },
    percentage() {
      return (item) =>
        item.value === 0 && item.status > pieAcademicProgress.Pending
          ? '0%'
          : item.value
          ? `${item.value}%`
          : '-';
    },
    percentageTotal() {
      return (value) => (value ? `${value}%` : null);
    },
    colorStatus() {
      return (value) => {
        const statusId = value?.status ? value.status : null;
        switch (statusId) {
          case pieAcademicProgress.Unavailable:
            return 'percent-unavailable';
          case pieAcademicProgress.Unset:
          case pieAcademicProgress.Pending:
            return 'percent-pending';
          case pieAcademicProgress.Submitted:
            return 'percent-submitted';
          case pieAcademicProgress.Discussed:
            return 'percent-discussed';
          case pieAcademicProgress.NotApply:
            return 'percent-not-apply';
          default:
            return 'percent-unavailable';
        }
      };
    },
  },
};
</script>

<style scoped>
.percent {
  height: 43px;
  width: 100px;
  border-radius: 4px;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.week-description {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.label-legend {
  display: flex;
  align-items: center;
}

.weeks-container > div {
  display: inline-block;
}

.percent-discussed {
  background-color: #d7fce9;
  border: solid 1px #a3e5b3;
}
.percent-submitted {
  background-color: #fff9db;
  border: solid 1px #f5c542;
}
.percent-pending {
  background-color: #ffebeb;
  border: solid 1px #fcc9c8;
}
.percent-unavailable {
  background-color: #e7efeb;
  border: solid 1px #b5c3bc;
}
.percent-not-apply {
  background-color: #e7efeb;
  border: solid 1px #b5c3bc;
}
.avg .percent {
  background-color: #e8fbfc;
  border: solid 1px #94d7da;
}
</style>
